<template>
  <div class="he-layout">
    <div class="he-layout--left">
      <Items :configs="formItemConfigs" />
    </div>
    <div class="he-layout--center">
      <Content :custom="custom" :hide-actions="hideActions" @confirm="changeDesign">
        <div slot="actions">
          <slot name="actions" :formDesignData="form" />
        </div>
        <div slot-scope="{data, model, type, prop}">
          <slot :data="data" :model="model" :type="type" :prop="prop" />
        </div>
      </Content>
    </div>
    <div v-if="settingData || !hideFormSettingPanel" class="he-layout--right">
      <Setting :data="settingData" :custom="custom" :hide-form-settings="hideFormSettings" :hide-form-setting-panel="hideFormSettingPanel">
        <template slot-scope="{data, model, type, prop}">
          <slot :data="data" :model="model" :type="type" :prop="prop" />
        </template>
      </Setting>
    </div>
  </div>
</template>

<script>
import Items from './Items'
import Content from './Content'
import Setting from './Setting'
import { initDefaultItems } from '../config'
import { NIL as uuidNil, v4 as uuidv4 } from 'uuid';

export default {
  name: 'HCreateForm',
  components: { Items, Content, Setting },
  provide() {
    return {
      formData: this.form,
      contentSelectChange: this.contentSelectChange,
    }
  },
  props: {
    value: {
      type: Object,
    },
    custom: Boolean,
    hideFormSettingPanel: Boolean,
    hideActions: {
      type: [Array, String],
      default: ''
    },
    hideElementNames: {
      type: [Array, String],
      default: ''
    },
    hideFormSettings: {
      type: [Array, String],
      default: ''
    },
    customElements: {
      type: [Array, null],
      default: null
    }
  },
  data() {
    return {
      form: {
        formDataId: '',
        formDataList: [],
        formStyle: {
          hideLabel: false,
          labelWidth: '100px',
          labelPosition: 'right',
          showRequiredAsterisk: true,
          showVerificationMessage: true,
          size: 'medium',
          labelSuffix: ':'
        },
      },
      settingData: null
    }
  },
  computed: {
    formItemConfigs() {
      const data = [
        ...initDefaultItems(this.hideElementNames),
        ...this.customElements
      ]
      return data
    }
  },
  watch: {
    value: {
      handler(val, oldval) {
        if (val && val !== oldval) {
          this.form.formDataId = val.formDataId || uuidv4()
          this.form.formDataList = val.formDataList
          this.form.formStyle = val.formStyle
        } else if (!val) {
          this.form.formDataId = uuidv4()
          this.form.formDataList = []
          this.form.formStyle = {
            hideLabel: false,
            labelWidth: '100px',
            labelPosition: 'right',
            showRequiredAsterisk: true,
            showVerificationMessage: true,
            size: 'medium',
            labelSuffix: ':'
          }
        }
      },
      deep: true
    }
  },
  created() {
    if (this.value) {
      this.form.formDataId = this.value.formDataId || uuidv4()
      this.form.formDataList = this.value.formDataList
      this.form.formStyle = this.value.formStyle
    } else {
      this.form.formDataId = uuidv4()
      this.form.formDataList = []
      this.form.formStyle = {
        hideLabel: false,
        labelWidth: '100px',
        labelPosition: 'right',
        showRequiredAsterisk: true,
        showVerificationMessage: true,
        size: 'medium',
        labelSuffix: ':'
      }
    }
  },
  methods: {
    changeDesign(val) {
      this.$emit('change', Object.assign({}, val))
    },
    // provide: content中点击选中元素，打开对应设置
    contentSelectChange(item) {
      this.settingData = item
    }
  }
}
</script>
<style lang="scss">
@import '../../index.scss';
.he-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;

  $lr-width: 360px;

  &--left {
    width: 255px;
    height: 100%;
    overflow-y: scroll;
  }

  &--center {
    display: flex;
    height: 100%;
    flex-grow: 1;
    overflow-y: scroll;
  }

  &--right {
    width: $lr-width;
    height: 100%;
    overflow-y: scroll;
  }

  & ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  & ::-webkit-scrollbar-track {
    background: transparent;
  }
  & ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(144,147,153,.3);
    transition: background-color .3s;
  }
  & ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(144,147,153, .5);
  }
}
</style>
